var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',{style:(_vm.iconStyle)},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }